module.exports = __webpack_public_path__ + "static/media/clasesUX-1.45039ce8.jpg";